import Joi from '@hapi/joi'

export const pluckerPerformanceReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Please select valid Division`,
        "any.required": `Division required`
    }),
    year: Joi.string().invalid("").label("Year").required().messages({
        "any.invalid": `Please select Year`,
        "any.required": `Year required`
    }),
}